import React from 'react'

import { LntTag } from '@app/components/base'
import { matchAbnormalStatusTagType, abnormalStatusTagText } from '@app/utils'

import type { AbnormalState } from '@app/types'

export const AbnormalStateStatusTagRender: React.FC<{ status: AbnormalState | null }> = ({ status }) => {
  const type = matchAbnormalStatusTagType(status)
  const statusText = abnormalStatusTagText(status)

  return <LntTag type={ type }>{ statusText }</LntTag>
}
